import useToast from "hooks/useToast";
import useHttp from "hooks/useHttpRequest";
import useInput from "hooks/useInput";
import React, { useEffect, useState } from "react";
import { Button, Form, Row, Col } from "react-bootstrap";

const ContactUsPremium = () => {
  const { showToast } = useToast();
  const {
    value: subject,
    hasError: subjectError,
    onChangeHandler: subjectChangeFn,
    onBlurHandler: subjectBlurFn,
    isValid: isSubjectValid,
    reset: resetSubject,
  } = useInput((value) => !!value);

  const {
    value: message,
    hasError: messageError,
    onChangeHandler: messageChangeFn,
    onBlurHandler: messageBlurFn,
    isValid: isMessageValid,
    reset: resetMessage,
  } = useInput((value) => !!value);

  const { response, error, hasError: responseHasError, request } = useHttp();
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (responseHasError) {
      showToast({
        message: "Something went wrong",
        type: 2,
      });
      setIsSubmitting(false);
      return;
    }
    if (response) {
      showToast({
        message: response.message,
        type: 1,
      });
      resetSubject();
      resetMessage();
      setIsSubmitting(false);
    }
  }, [response, responseHasError, resetMessage, resetSubject]);

  const submit = async (e) => {
    e.preventDefault();

    if (isSubjectValid && isMessageValid) {
      setIsSubmitting(true);
      const data = {
        subject,
        message,
      };
      await request("submitUserQuery", "POST", data);

      return;
    }

    messageBlurFn(true);
    subjectBlurFn(true);
  };

  return (
    <Form className="form">
      <Form.Group className="mb-3" controlId="subject">
        <Form.Label>Subject</Form.Label>
        <Form.Control
          type="text"
          placeholder="Subject"
          value={subject}
          name="subject"
          onChange={(e) => subjectChangeFn(e.target.value)}
          onBlur={subjectBlurFn.bind(this, true)}
          autoComplete="off"
          isInvalid={subjectError}
        />
        {subjectError && (
          <Form.Control.Feedback type="invalid">
            Please enter a valid subject
          </Form.Control.Feedback>
        )}
      </Form.Group>
      <Form.Group className="mb-3" controlId="message">
        <Form.Label>Message</Form.Label>
        <Form.Control
          as="textarea"
          style={{ paddingLeft: "0.7rem", paddingBottom: "0.7rem" }}
          value={message}
          placeholder="Message"
          onChange={(e) => messageChangeFn(e.target.value)}
          onBlur={messageBlurFn.bind(this, true)}
          name="message"
          isInvalid={messageError}
        />
        {messageError && (
          <Form.Control.Feedback type="invalid">
            Please enter a valid message
          </Form.Control.Feedback>
        )}
      </Form.Group>
      <Row className="contact-form-btns">
        <Col md={12} className="text-md-end">
          
          <Button
            onClick={submit}
            variant="primary"
            className="btn-round contact-save-btn"
            disabled={isSubmitting} 
          >
            {isSubmitting ? "Submitting..." : "Submit"}
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default ContactUsPremium;
